/**
 * A single tab page. It renders the passed template
 * via the @Input properties by using the ngTemplateOutlet
 * and ngOutletContext directives.
 */

import { Component, Input } from '@angular/core';

@Component({
  selector: 'my-tab',
  styles: [
    `
      .pane {
        padding: 0em;
      }
      .tab-content {
        height: 100%;
      }
    `,
  ],
  template: `
    <div [hidden]="!active" class="pane tab-content">
      <ng-content></ng-content>
      <ng-container
        *ngIf="template"
        [ngTemplateOutlet]="template"
        [ngOutletContext]="{ data: dataContext, tabIndex: tabIndex }"
      >
      </ng-container>
    </div>
  `,
})
export class TabComponent {
  @Input('tabTitle') title: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template;
  @Input() dataContext;
  @Input() tabIndex;
}



// WEBPACK FOOTER //
// ./src/app/layout/tabs/tab.component.ts